import Vue from "vue";
import Loading from "./loading.vue";
const Mask = Vue.extend(Loading);

const relativeClass = "p-relative";
const loadingChange = (el, binding) => {
  if (binding.value) {
    el.classList.add(relativeClass);
    el.appendChild(el.mask);
  } else {
    el.classList.remove(relativeClass);
    el.mask.remove();
  }
};
export default {
  install: Vue => {
    if (Vue.prototype.$isServer) return;

    Vue.directive("loading", {
      // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
      bind: function(el, binding) {
        const mask = new Mask({
          el: document.createElement("div"),
          data: {
            visible: binding.value
          }
        });
        el.instance = mask;
        el.mask = mask.$el;
        loadingChange(el, binding);
      },

      update: function(el, binding) {
        if (binding.value !== binding.oldValue) {
          loadingChange(el, binding);
        }
      },

      unbind: function(el) {
        el.classList.remove(relativeClass);
        el.mask.remove();
        el.instance && el.instance.$destroy();
      }
    });
  }
};
